module.exports = __webpack_public_path__ + "f8b0d5a9ac4006ad3031052476de8a24.svg";